"use strict";

require("core-js/modules/es6.string.link");

require("core-js/modules/es6.object.define-property");

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var styled_components_1 = require("styled-components");

exports.fontUrl = "https://menu.cdn.bitcoindotcom.net/uni/dist/fonts.css";
exports.GlobalStyle = styled_components_1.createGlobalStyle(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  html {\n    scroll-behavior: smooth;\n  }\n\n  html,\n  body,\n  ___gatsby,\n  ___gatsby > div {\n    font-family: ", ";\n    margin: 0;\n    padding: 0;\n    color: ", ";\n    \n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n    overflow-x: hidden;\n\n    font-size: 16px;\n    background-color: ", ";\n  }\n\n  a {\n    display: inline-block;\n    color: ", ";\n    letter-spacing: 0;\n    font-weight: 600;\n    text-decoration: none;\n  }\n"], ["\n  html {\n    scroll-behavior: smooth;\n  }\n\n  html,\n  body,\n  ___gatsby,\n  ___gatsby > div {\n    font-family: ", ";\n    margin: 0;\n    padding: 0;\n    color: ", ";\n    \n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n    overflow-x: hidden;\n\n    font-size: 16px;\n    background-color: ", ";\n  }\n\n  a {\n    display: inline-block;\n    color: ", ";\n    letter-spacing: 0;\n    font-weight: 600;\n    text-decoration: none;\n  }\n"])), function (_a) {
  var theme = _a.theme;
  return theme.typography.fontFamily;
}, function (_a) {
  var theme = _a.theme;
  return theme.palette.text["default"];
}, function (_a) {
  var theme = _a.theme;
  return theme.palette.background["default"];
}, function (_a) {
  var theme = _a.theme;
  return theme.palette.text.link || "";
});
var templateObject_1;